module.exports = __webpack_public_path__ + "assets/img/stars.803c9eef.png";